import { useCallback } from 'react';
import type { TypedUseSelectorHook } from 'react-redux';
import { useDispatch, useSelector } from 'react-redux';
import type { AsyncThunkAction } from '@reduxjs/toolkit';
import { unwrapResult } from '@reduxjs/toolkit';
import type { AppDispatch, RootState } from '@store/store.ts';
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

type PlainAction = { type: string };

export type AppDispatchFn = {
    <R, T = unknown>(action: AsyncThunkAction<R, T, any>): Promise<R>;
    (action: PlainAction): void;
};

export const useAppDispatch = (): AppDispatchFn => {
    const dispatch = useDispatch<AppDispatch>();

    const appDispatch = useCallback(
        (action: any) => {
            const res = dispatch(action);
            if (res && typeof (res as any).then === 'function') {
                return (res as Promise<any>).then(unwrapResult);
            }
        },
        [dispatch],
    );
    return appDispatch as AppDispatchFn;
};
